import React from 'react'
import PropTypes from 'prop-types'
import css from './styles/go-back-button.css'

const GoBackButton = (props) => (
  <div className={css.wrapper}>
    <button
      className={css.button}
      onClick={props.onClick}
    >
      <span className={css.label}>RESELECT TARGET GROUP</span>
    </button>
  </div>
)

GoBackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default GoBackButton



// WEBPACK FOOTER //
// ./src/components/Messages/GoBackButton.js